import { NextPage } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import {
  Breadcrumb,
  GlobalErrorFallback,
  ProductListingContainer,
  ProductListingWithRedisContainer,
} from 'components';
import { BaseContainer } from 'styles/sharedStyles';
import { LoadingBar } from 'components/core';
import { getInitialProps } from 'utils/nextServerFuncitons';
import { isProductCacheEnabled } from 'utils';
import { useFetchTaxonDetails } from 'reactQuery/queries';

const CategoryDetailsPage: NextPage = () => {
  const router = useRouter();
  let taxonSlug = router.query.slug;

  if (typeof taxonSlug === 'object') {
    taxonSlug = taxonSlug.join('/');
  } else {
    throw new Error('Category slug not found.');
  }

  const taxonDetails = useFetchTaxonDetails(taxonSlug);

  if (taxonDetails.isLoading || taxonDetails.isIdle) {
    return <LoadingBar />;
  }
  if (taxonDetails.isError) {
    return <GlobalErrorFallback />;
  }

  return (
    <>
      <Head>
        <title>{taxonDetails.data.taxon.title}</title>
      </Head>
      <BaseContainer>
        <Breadcrumb items={taxonDetails.data.taxon.breadCrumb} />

        {/* key={router.asPath} forces full remount when the category route changes, preventing stale
            Redis-cached products from the previous category bleeding into the next render.
            Mirrors the same key already present on ProductListingContainer below. */}
        {isProductCacheEnabled() ? (
          <ProductListingWithRedisContainer
            taxonDetails={taxonDetails.data}
            key={router.asPath}
          />
        ) : (
          <ProductListingContainer
            taxonDetails={taxonDetails.data}
            key={router.asPath}
          />
        )}
      </BaseContainer>
    </>
  );
};

CategoryDetailsPage.getInitialProps = getInitialProps;

export default CategoryDetailsPage;
